<template>
    <div id="page-user-view">
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
                    <vs-tab label="Information" icon-pack="feather" icon="icon-info">
                        <div class="tab-text">
                            <client-infos :client="client"/>
                        </div>
                    </vs-tab>
                    <vs-tab @click="getContracts()" label="Contrats" icon-pack="feather" icon="icon-file">
                        <div class="tab-text">
                            <client-contrats
                              :contracts="contracts"
                              :getContracts="getContracts"
                            />
                        </div>
                    </vs-tab>
                    <vs-tab @click="customerUser()" label="Utilisateurs" icon-pack="feather" icon="icon-users">
                        <div class="tab-text">
                            <client-users :users="users"
                                          :customerUser="customerUser"
                            />
                        </div>
                    </vs-tab>
                </vs-tabs>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import ClientInfos from "./components/ClientInfos";
    import ClientContrats from "./components/ClientContrats";
    import ClientUsers from "./components/ClientUsers";
    export default {
        components: {ClientInfos, ClientContrats, ClientUsers},
        data() {
            return {
                activeTab: 0,
                showSidebar: false,
              users: [],
              contracts: [],
                sidebarData: {},
                client: {},
            }
        },
        mounted() {
            this.loadClientInfo()
        },
      methods: {
        getContracts(){
          this.$vs.loading()
          this.$http.get('/contracts/customers?id='+ this.$route.params.id).then((response) => {
            this.contracts = response.data
            this.$vs.loading.close()
          }).catch((error) => {
            this.$vs.loading.close()
          })
        },

        customerUser(){
          this.$vs.loading()
          this.$http.get('/customers/users?track='+ this.$route.params.id).then((response) => {
            this.users = response.data
            this.$vs.loading.close()
          }).catch((error) => {
            this.$vs.loading.close()
          })
        },
            toggleSidebar(val = false) {
                this.showSidebar = val;
            },
            edit(){
                // this.sidebarData = data;
                this.toggleSidebar(true);
            },
            loadClientInfo(){
              this.$vs.loading()
              this.$http.get('/customers/detail/'+ this.$route.params.id).then((response) => {
                this.client = response.data
                this.$vs.loading.close()
              }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401) {
                  this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                  })
                  this.$router.push({name: "login"})
                }else {
                  console.log(error)
                }
              })
            }
        }
    }
</script>
